import React from 'react';
import ManageByCourse from './ManageByCourse';
import ManageByClassroom from './ManageByClassroom';
import ManageByStudent from './ManageByStudent';

export function TaskManagement(props) {
  const { selectedTab, uri } = props;

  return (
    <>
      {selectedTab === 'curso' && (
        <ManageByCourse
          selectedTab={selectedTab}
          uri={uri}
        />
      )}
      {selectedTab === 'turma' && (
        <ManageByClassroom
          selectedTab={selectedTab}
          uri={uri}
        />
      )}
      {selectedTab === 'estudante' && (
        <ManageByStudent
          selectedTab={selectedTab}
          uri={uri}
        />
      )}
    </>
  );
}

export * from './ManageExcessTasks';
export * from './ManageExcessStudentTasks';
